import axios from "axios";

export const StripeTransport = {
    getPaymentLink: async (price: number) => {
        const { data } = await axios.get(`/stripe/paymentLink?price=${price}`, {});
        return data;
    },
};
